import React, { useEffect, useRef, useState } from "react";
import NavBar from "components/SideBar/SideBar2";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import TableHeader from "../Utility/TableHeader";
import { getEntityList, profileInfo, setDefaultEntity, setPeriodStore, setPeriodStoreSingle, storeSelectedGstinGSTR2A2BNEW } from "../action";
import { useDispatch, useSelector } from "react-redux";
import HeaderBar from "./HeaderBar";
import { recoHeaders } from "./constants";
import {
  getDownloadReportData,
  getGenerateReport,
  getPipelineStatus,
  getRecoHistory,
  getRecoTablesData,
  getUploadReportData,
  setActiveTabReco,
  setRecoSelection,
  setSearchStr,
  setSelectedMatched,
  setSelectedMismatch,
  setSelectedNotInGstn,
  setSelectedNotInPR,
  setSelectedProbable,
  setSelectedRejected,
  setSelectedRowMatched,
  setSelectedRowMismatch,
  setSelectedRowNotInGstn,
  setSelectedRowProbable,
  setSelectedRowRejected,
  setSelectedYear,
  setSelection,
} from "./action";
import RecoHistory from "./RecoHistory/RecoHistory";
import ViewReco from "./ViewReco/ViewReco";
import RecoReport from "./RecoReport/RecoReport";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS, GSTR2A2BNEW_MSGS } from "Constant/Messages";

const Gstr2A2BReconciliation = (props) => {
  const dispatch = useDispatch();
  // const [selection, setSelection] = useState("");
  // const [recoSelection, setRecoSelection] = useState("");
  // const [selectedYear, setSelectedYear] = useState("");
  const [taxableValue, setTaxableValue] = useState("");
  const [taxRate, setTaxRate] = useState("");

  const interval = useRef("");
  // const [dateRange, setDateRange] = useState([
  //   {
  //     // startDate: getStartDate(selectedYear),
  //     // endDate:  getEndDate(selectedYear),
  //     startDate: new Date(),
  //     endDate: new Date(),
  //     key: "selection",
  //   },
  // ]);
  const [runReco, setRunReco] = useState(true);
  const [runFuzzy, setRunFuzzy] = useState(true);
  const [includeITC, setIncludeITC] = useState(true);

  const {
    activeTabReco,
    activeTabViewReco,
    activeTabDocView,
    loaderStatus,
    dateRange,
    searchStr,
    pageNoRecoHistory,
    selection,
    recoSelection,
    selectedYear,
    rgstinTaxpayerFilter,
    sgstinTaxpayerFilter,
    inumFilter,
    monthFilter,
    month3bFilter,
    baseDataFilter,
    availedFilter,
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);
  const { defaultEntity, selectedGstin,entityLabel } = useSelector(
    (store) => store.gstr2a2bNewCommonReducer
  );
  useEffect(() => {
    dispatch(getEntityList());
  }, []);
  function handleTabChange(id) {
    dispatch(setActiveTabReco(id));
  }
  useEffect(() => {console.log('entityLabel::',entityLabel)}, [entityLabel]);
  const handleGenerateReport = async (search = "", msgFlag = true) => {
    console.log("Inside handleGenerateReport");
    if (
      defaultEntity &&
      selectedGstin?.length > 0 &&
      selection &&
      recoSelection &&
      selectedYear &&
      (selection !== 'Document Date' || (dateRange && dateRange[0]?.startDate && dateRange[0]?.endDate))
      //  &&(taxRate || taxableValue)
    ) {
      await dispatch(
        getGenerateReport(
          selectedGstin,
          selection,
          recoSelection,
          selectedYear,
          taxRate,
          taxableValue,
          dateRange,
          runReco,
          runFuzzy,
          includeITC,
          search,
          activeTabReco,
          activeTabViewReco,
          activeTabDocView,
          entityLabel
        )
      );
      getHistoryData();
    } else {
      if (msgFlag === true) {
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      }
    }
  };
  // useEffect(()=>{console.log("dateRange::",dateRange)},[dateRange])
  // History data polling
  // Helper function to count in-process files
  const countInProcessFiles = (files) =>
    files?.filter(
      (item) =>
        !["COMPLETED", "FAILED"].includes(item?.PIPELINE_STATUS?.toUpperCase())
    )?.length || 0;

  const getInProcessFileIds = (files) =>
    files
      ?.filter(
        (item) =>
          !["COMPLETED", "FAILED"].includes(
            item?.PIPELINE_STATUS?.toUpperCase()
          )
      )
      .map((item) => item?.UUID) || [];

  const getHistoryData = async (
    search = '',
    pageNoHistory = pageNoRecoHistory
  ) => {
    try {
      // Clear any previous interval
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }

      // Initial fetch
      let fileDataTemp = await dispatch(getRecoHistory(search, pageNoHistory));
      let inProcessStatusCount = countInProcessFiles(fileDataTemp);

      if (fileDataTemp?.length > 0 && inProcessStatusCount > 0) {
        interval.current = setInterval(async () => {
          try {
            // Fetch updated history
            fileDataTemp = await dispatch(
              getRecoHistory(search, pageNoHistory)
            );
            inProcessStatusCount = countInProcessFiles(fileDataTemp);

            // Get IDs of in-process files
            const inProcessFileIds = getInProcessFileIds(fileDataTemp);

            if (inProcessFileIds.length > 0) {
              console.log("UUID arrays ::", inProcessFileIds);
              await dispatch(getPipelineStatus(inProcessFileIds));
            }

            if (inProcessStatusCount === 0) {
              clearInterval(interval.current);
              interval.current = null;
              console.log("All files processed.");
            }
          } catch (error) {
            console.error("Polling error:", error);
            clearInterval(interval.current);
            interval.current = null;
          }
        }, 10000);
      }
    } catch (error) {
      console.error("Error fetching history data:", error);
      errorToastMessage(GSTR2A2BNEW_MSGS.ERROR_FETCHING_HISTORY);
    }
  };

  const clearSelected = () => {
    dispatch(setSelectedMatched([]));
    dispatch(setSelectedProbable([]));
    dispatch(setSelectedMismatch([]));
    dispatch(setSelectedNotInPR([]));
    dispatch(setSelectedNotInGstn([]));
    dispatch(setSelectedRejected([]));
    dispatch(setSelectedRowMismatch([]));
    dispatch(setSelectedRowNotInGstn([]));
    dispatch(setSelectedRowProbable([]));
    dispatch(setSelectedRowMatched([]));
    dispatch(setSelectedRowRejected([]));
  };

  const handleSubmit = async (msgFlag = true, search = "", filterGstin = []) => {
    console.log('HERE IN HANDLE SUBMIT');
    try {
      if (
        defaultEntity && selectedGstin &&
        selectedGstin?.length > 0 &&
        selection &&
        recoSelection &&
        selectedYear &&
              (selection !== 'Document Date' || (dateRange && dateRange[0]?.startDate && dateRange[0]?.endDate))

      ) {
        console.log('search should be cleared');
        dispatch(setSearchStr(""));
         if (activeTabReco === "1") {
          getHistoryData('',1);
          return console.log("History data fetched successfully.");
         }
        if (activeTabReco === "2" && activeTabViewReco === "5") {
          await dispatch(getUploadReportData("", 1, msgFlag));
        } else if (activeTabReco === "2" && activeTabViewReco === "4") {
          await dispatch(
            getDownloadReportData(
              selectedGstin,
              recoSelection,
              selection,
              selectedYear,
              dateRange,
              "",
              msgFlag
            )
          );
        } else {
          await dispatch(
            getRecoTablesData(
              selectedGstin,
              selection,
              recoSelection,
              selectedYear,
              dateRange,
              activeTabReco,
              activeTabViewReco,
              activeTabDocView,
              1,
              rgstinTaxpayerFilter,
              sgstinTaxpayerFilter,
              inumFilter,
              monthFilter,
              month3bFilter,
              baseDataFilter,
              availedFilter,
              search,
              msgFlag,
              filterGstin
            )
          );
        }
       clearSelected()


      } else {
        console.log("Please fill in all mandatory fields.");
        if (msgFlag == true) {
          errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
        }
      }
    } catch (error) {
      console.log("Error in handleSubmit:", error);
    }
  };
   useEffect(()=>{
    return () => {
      console.log('Selected filters cleared on component unmount');
      dispatch(setDefaultEntity(''));
      dispatch(storeSelectedGstinGSTR2A2BNEW([]));
      dispatch(profileInfo([]));
      dispatch(setPeriodStoreSingle(null));
      dispatch(setPeriodStore(null, null));
      dispatch(setSelection(''));
      dispatch(setRecoSelection(''));
      dispatch(setSelectedYear(''));
      setTaxRate('');
      setTaxableValue('');
    }
  }, []);
  return (
    <div>
      <NavBar
        currentPage={"GSTR-2A/2B  | Reconciliation"}
        module="gstr2a2bNew"
        history={props.history}
      >
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="sweet-loading">
          <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
        </div>

        <HeaderBar
          runReco={runReco}
          runFuzzy={runFuzzy}
          includeITC={includeITC}
          setRunReco={setRunReco}
          setRunFuzzy={setRunFuzzy}
          setIncludeITC={setIncludeITC}
          dateRange={dateRange}
          // setDateRange={setDateRange}
          taxRate={taxRate}
          setTaxRate={setTaxRate}
          taxableValue={taxableValue}
          setTaxableValue={setTaxableValue}
          selectedYear={selectedYear}
          selection={selection}
          recoSelection={recoSelection}
          // setSelectedYear={setSelectedYear}
          // setSelection={setSelection}
          // setRecoSelection={setRecoSelection}
          handleGenerateReport={handleGenerateReport}
          handleSubmit={handleSubmit}
        />

        <div
          style={{
            display: "flex",
            height: "3em",
            boxShadow: "0px 2px 3px 0px #8080805e",
            paddingRight: "5px",
          }}
        >
          <TableHeader
            handleTabChange={handleTabChange}
            columns={recoHeaders}
            activeTab={activeTabReco}
          />
        </div>
        <div style={{ marginTop: "0.6em" }}>
          {activeTabReco === "1" && (
            <RecoHistory
              handleGenerateReport={handleGenerateReport}
              getHistoryData={getHistoryData}
              interval={interval}
            />
          )}
          {activeTabReco === "2" && <ViewReco handleSubmit={handleSubmit} />}
          {activeTabReco === "3" && <RecoReport handleSubmit={handleSubmit} />}
        </div>
      </NavBar>
    </div>
  );
};

export default Gstr2A2BReconciliation;
